module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightpartcloud-dd0403ac3780911d72b7f255003b3934.svg";